import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP,
    libraries: 'places,drawing',
    v: '3.64',
    region: 'AR',
    language: 'ar',
  },
});
